import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { strings } from '@constants'
import { updateOrganisationApi } from '@data/conn/put/organisation'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Input } from '@baseV2'

import { InputsWrapper } from '../styles'

const AddVendorId = ({ orgId, orgData, update }) => {
	const dispatch = useDispatch()

	const [vendorId, setVendorId] = useState(orgData?.mapping?.oracle_vendor_id ?? '')

	const disabled = !vendorId.trim() || vendorId.trim() === (orgData?.mapping?.oracle_vendor_id ?? '')

	const submitHandler = () => {
		if (disabled) return
		dispatch(showLoader(true))
		updateOrganisationApi(orgId, 'ORACLE_VENDOR_ID', vendorId.trim())
			.then(() => {
				dispatch(showToast(true, strings('organisation_update_success'), { type: TOAST_TYPE.SUCCESS }))
				dispatch(toggleDrawer(false))
				update?.()
			})
			.catch((err) => {
				dispatch(showToast(true, err?.response?.data?.message ?? strings('organisation_update_failure'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<Input
						id='org-vendor-id-v2'
						label={strings('oracle_vendor_id')}
						placeholder='Enter vendor id'
						value={vendorId}
						onChange={(e) => setVendorId(e.target.value.trim())}
					/>
				</InputsWrapper>
			</DrawerBodyWrapper>

			<DrawerFooterWrapper>
				<Button color='primary' disabled={disabled} onClick={submitHandler}>
					{strings('update')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default AddVendorId
